import { Paper, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const FoodandBeveragesAcknowledgement = ({
  applicationDetails,
  applicationNumber,
  basePath,
  totalAmountPayable,
  totalAmountWithoutTax,
  totalTaxAmount
}) => {
  const navigate = useNavigate();

  return (
    <Paper sx={{ borderRadius: 2, boxShadow: 3 }}>
      <Typography variant="h4" sx={{ mb: 2, textAlign: 'center' }}>
        Payment Acknowledgement
      </Typography>
      <Typography>
        Hello <strong>{applicationDetails?.userName}</strong>,
      </Typography>

      <>
        <Typography sx={{ mt: 1 }}>
          Your payment of <strong>${totalAmountPayable} </strong>
          for Application <strong>#{applicationNumber} </strong>
          has been received, including <strong>
            ${totalAmountWithoutTax}
          </strong>{' '}
          for the Food and Beverages application and
          <strong> ${totalTaxAmount}</strong> for online convenience fees.
        </Typography>
        <Typography sx={{ mt: 1 }}>
          It will be processed shortly. We will keep you posted on the status of
          your application through email.
        </Typography>
        <Typography sx={{ mt: 1 }}>
          Please visit our <a href="_">website</a> to get details on next steps.
        </Typography>
      </>

      <Typography sx={{ mt: 1 }}>
        If you have any further questions, please contact us at{' '}
        <a href={`mailto:${'EngineeringDepartment'}@techgov.com`}>
          {'EngineeringDepartment'}@techgov.com
        </a>
        .
      </Typography>
      <br />
      <Typography sx={{ mt: 1 }}>
        Thank you, <br />
        Department of Health and Mental Hygiene
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Button
          variant="outlined"
          onClick={() => navigate(`${basePath}/application-list`)}
        >
          View My Applications
        </Button>
      </Box>
    </Paper>
  );
};

export default FoodandBeveragesAcknowledgement;
